module.exports = __webpack_public_path__ + "img/3x.0d645d4.jpg";